import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(1)};

  svg {
    flex-shrink: 0;

    ${mediaMin.compactPhoneBreakpoint`
      &.grade-a {
        width: 33cqw;
      }

      &.grade-b {
        width: 36cqw;
      }

      &.grade-c {
        width: 39cqw;
      }

      &.grade-d {
        width: 42cqw;
      }

      &.grade-e {
        width: 45cqw;
      }

      &.grade-f {
        width: 48cqw;
      }

      &.grade-g {
        width: 51cqw;
      }
    `}
  }
`;

export const GradeWithDescription = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.space(4)};

  ${mediaMin.compactPhoneBreakpoint`
    gap: ${props => props.theme.space(2)};
  `}
`;

export const GradeDescription = styled.span`
  color: ${props => props.theme.colors.cornFlowerBlue};

  ${mediaMin.compactPhoneBreakpoint`
    font-size: ${props => props.theme.rem(14)};
  `}
`;
